import { render } from "./dialog-confirm.vue?vue&type=template&id=6f2276d9&scoped=true&ts=true"
import script from "./dialog-confirm.vue?vue&type=script&lang=ts"
export * from "./dialog-confirm.vue?vue&type=script&lang=ts"

import "./dialog-confirm.vue?vue&type=style&index=0&id=6f2276d9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f2276d9"],['__file',"src/vue/composants/dialog-confirm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f2276d9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f2276d9', __exports__)) {
    api.reload('6f2276d9', __exports__)
  }
  
  module.hot.accept("./dialog-confirm.vue?vue&type=template&id=6f2276d9&scoped=true&ts=true", () => {
    api.rerender('6f2276d9', render)
  })

}


export default __exports__